import React from "react";
import "./loader.scss";
import { Spinner } from "reactstrap";
import loaderBack from "../../assets/images/project-img/loader-back.svg"

const Loader = () => (
  <div className="fallback-spinner fallback-loader">
    <img src={loaderBack} alt="loader" />
    <div className="loading">
      <Spinner color="success" />
    </div>
  </div>
);
export default Loader;
